export default {
  getFlags: state => state.flags || [],
  getHasSearchedFlag: state => state.hasSearchedFlag || false
}